import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";

export const Statement = ({ onAnswer, isTransitioning, direction }) => {
    const [showLogo, setShowLogo] = useState(false);
    const [showTitle, setShowTitle] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    
    useEffect(() => {
        setTimeout(() => setShowLogo(true), 200);
        setTimeout(() => setShowTitle(true), 600);
        setTimeout(() => setShowDescription(true), 1000);
        setTimeout(() => setShowButton(true), 1400);
    }, []);
    
    const handleContinue = () => {
        setIsExiting(true);
        setTimeout(() => onAnswer('continue'), 800);
    };
    
    return (
        <div className={classNames(
            "relative h-full flex flex-col items-center justify-start px-6",
            {
                "opacity-0": isTransitioning || isExiting,
            },
            "transition-all duration-500"
        )}>
            <div className="text-center space-y-6 w-full mt-[150px]">
                {/* Logo */}
                <div className="overflow-hidden mb-8">
                    <div className={classNames(
                        "transition-all duration-500",
                        showLogo ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                    )}>
                        <img
                            src="/assets/Logo%20lockup.png"
                            alt="Atly"
                            className="h-12 md:h-16 w-auto mx-auto"
                        />
                    </div>
                </div>
                
                {/* Title */}
                <div className="overflow-hidden">
                    <h1
                        className={classNames(
                            "text-[28px] md:text-[40px] leading-tight font-bold transition-all duration-500 text-black",
                            showTitle ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                        )}
                    >
                        The{' '}
                        <span
                            className="animate-shimmer bg-[length:200%_100%] bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            #1 Gluten-Free
                        </span>
                        {' '}map
                    </h1>
                </div>
                
                {/* Description */}
                <div className="overflow-hidden mb-8">
                    <p className={classNames(
                        "text-xl md:text-2xl text-gray-600 transition-all duration-500",
                        showDescription ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"
                    )}>
                        Easily find safe gluten-free places worldwide by personalizing your map.
                    </p>
                </div>
                
                {/* Continue Button */}
                <div className={classNames(
                    "transition-all duration-500 px-5",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}>
                    <PorangeButton
                        full={true}
                        className="h-[56px] rounded-[16px] text-lg shadow-md"
                        onClick={handleContinue}
                    >
                        Continue Personalizing
                    </PorangeButton>
                </div>
                
                {/* Emblem */}
                <div className={classNames(
                    "transition-all duration-500 mt-6",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
                )}>
                    <img
                        src="/assets/emblem.png"
                        alt="Atly Emblem"
                        className="w-[512px] object-contain mx-auto"
                    />
                </div>
            </div>
            
            <style jsx global>{`
                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }

                .animate-shimmer {
                    animation: shimmer 3s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default Statement;